class Media extends HTMLElement {
  constructor() {
    super();

    this.isMobile = window.matchMedia("(max-width: 749px)").matches;
    this.video = this.getVideo();
    this.state = this.querySelector(".js-state");
    this.states = this.querySelectorAll(".js-state");
    this.volume = this.querySelector(".js-volume");
    this.progress = this.querySelector(".js-progress .circle");
    this.mobilePoster = this.dataset.poster;
    this.playWhenNotVisible = this.dataset.playWhenNotVisible;
    this.userPaused = false;

    this.addListeners();
  }

  getVideo() {
    const mobileVideo = this.querySelector(".js-video-mobile");
    const video = this.querySelector(".js-video");

    return this.isMobile && mobileVideo ?  mobileVideo : video;
  }

  addListeners() {
    this.states.forEach(state => state.addEventListener("click", () => this.toggleVideoPlayState(true)));
    this.volume.addEventListener("click", () => this.toggleVideoVolume());

    if (this.states.length > 1) {
      this.video.addEventListener("play", () => this.toggleVideoIconsMultiple(this.states));
      this.video.addEventListener("pause", () => this.toggleVideoIconsMultiple(this.states));
    } else {
      this.video.addEventListener("play", () => this.toggleVideoIcons("state"));
      this.video.addEventListener("pause", () => this.toggleVideoIcons("state"));
    }
    
    this.video.addEventListener("timeupdate", () => this.progressLoop());

    if (this.dataset.autoplay === "true") this.addObserver();
  }

  toggleVideoPlayState(userClick) {
    this.video.paused || this.video.ended
      ? this.video.play()
      : this.video.pause();

    if (userClick) this.userPaused = this.video.paused;
  }

  toggleVideoVolume() {
    this.video.muted = !this.video.muted;

    this.toggleVideoIcons("volume");
  }

  toggleVideoIcons(type) {
    if (this[type] == null) return;

    if (this[type].classList.contains("media__icons-center--active")) {
      this[type].classList.toggle("media__icons-center--active");
    } else {
      this[type].classList.toggle("media__icons--active");
    }
  }

  toggleVideoIconsMultiple(states) {
    states.forEach(state => {
      if (state.classList.contains('media__icons-center--active')) {
        state.classList.toggle('hidden', !this.video.paused);
      } else {
        state.classList.toggle('media__icons--active')
      }
    })
  }

  progressLoop() {
    if (this.video.paused) return;

    const total = this.progress.style.strokeDasharray
    const increment = Number(total) / 100
    const percentage = Math.round((this.video.currentTime / this.video.duration) * 100);

    if (percentage === 100) return;

    this.progress.style.strokeDashoffset = String(total - (percentage * increment));
  }

  addObserver() {
    const options = { root: null, rootMargin: "-10% 0px 0px 0px", threshold: 0 };

    this.observer = new IntersectionObserver(this.autoplay.bind(this), options);
    this.observer.observe(this);
  }

  autoplay(entries) {
    if (this.userPaused) return;

    if (entries[0].isIntersecting) {
      this.video.play();
    } else if (!this.playWhenNotVisible) {
      this.video.pause();
    }
  }
}

customElements.define("media-wrapper", Media);